module.exports = __webpack_public_path__ + "static/img/iconfont.4f0706f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont.svg
// module id = jLkr
// module chunks = 1